<!--编辑分组信息-->
<template>
  <modal :visible.sync='visible' style='padding: 20px' :title="group.id? $t('public.add_group'):$t('public.add_group')" width='400px'>
    <el-form :model='group' label-width='110px'>
      <el-form-item :label="$t('integration.group_name')">
        <el-input v-model='groupItem.group_name' style='width: 250px'></el-input>
      </el-form-item>
      <el-form-item :label="$t('public.curr_group')">
        <el-switch
          v-model='groupItem.current'
          :active-value='1'
          :inactive-value='0'
        >
        </el-switch>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type='primary' @click='confirm'>{{ $t('integration.confirm') }}</el-button>
      <el-button @click='close'>{{ $t('public.btn_close') }}</el-button>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    group: {
      type: Object
    }
  },
  watch: {
    group (newval) {
      this.groupItem = { ...newval }
    }
  },
  computed: {
    visible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  data () {
    return {
      groupItem: {}
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    confirm () {
      this.$emit('confirm', this.groupItem)
      this.close()
    }
  }
}
</script>
